import api from './http';

export const me = async () => (await api.get('/me')).data;
export const login = async (payload) => (await api.post('/login', payload)).data;
export const logout = async () => (await api.post('/logout')).data;
